import { jsx as _jsx } from "react/jsx-runtime";
import AnimatedLink from "@components/link/AnimatedLink";
const LocalNavigationItem = ({ link: { title, url } }) => _jsx(AnimatedLink, { className: "local-nav-item", label: title, url: url, color: "charcoal" });
export default LocalNavigationItem;
